let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h3C0X")).then(() => parcelRequire('3QxlH'));